import Image from "next/image"
import richText from "utilities/richText"
import Modal from "components/Modal"
import Link from "next/link"
import CallToAction from "components/CallToAction"
import useModal from "utilities/useModal"
import getStoryblokLink from "utilities/getStoryblokLink"

function Card({ icon, title, content, apply_now_link, full_description }) {
  const anchor = title.replaceAll("/", "-").replaceAll(" ", "-").toLowerCase()
  const modalProps = useModal(anchor)

  return (
    <>
      <Modal {...modalProps}>
        <div className="sm:max-h-[40dvh] overflow-y-scroll prose-h2:pb-4 pr-4">{richText(full_description)}</div>
      </Modal>

      <div className="px-8 my-8 first:mt-0 last:mb-0">
        <div className="max-w-screen-xl mx-auto flex flex-col lg:flex-row  rounded-2xl shadow-xl">
          <div className="basis-1/5 bg-gray-light py-4 px-4 sm:py-8 sm:px-8 justify-center w-full">
            <Image
              src={icon.filename}
              alt={icon.alt}
              width={219}
              height={175}
              className="max-h-36 sm:max-h-full mx-auto relative lg:top-1/2 lg:-translate-y-1/2"
            />
          </div>
          <div className="basis-4/5 px-6 py-8">
            <h3 className="text-m1 font-bold pb-3">{title}</h3>
            <div className="prose-p:leading-7 pb-3">{richText(content)}</div>
            <Link href={`#${anchor}`} className="text-green-pine font-bold underline hover:no-underline block pb-4">
              Read Full Job Description
            </Link>
            <CallToAction href={getStoryblokLink(apply_now_link)}>Apply Now</CallToAction>
          </div>
        </div>
      </div>
    </>
  )
}

export default function JobPositionCards({ blok }) {
  return (
    <section className="py-12">
      <div className="text-center max-w-2xl mx-auto px-8 prose-h2:text-l1 lg:prose-h2:text-xl1 prose-h2:pb-2">
        {richText(blok.intro_content)}
      </div>
      {blok.cards.map((card, idx) => (
        <Card {...card} key={idx} />
      ))}
    </section>
  )
}
